// extracted by mini-css-extract-plugin
module.exports = {"layoutImage":"style_layoutImage__ZunDm"};